module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNCIgaGVpZ2h0PSI2IiB2aWV3Qm94PSIwIDAgNCA2IiBmaWxsPSJub25lIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPg0KPHBhdGggZD0iTTMuMjk3NDkgMS45NjA4MUMzLjY1NTc0IDIuMzQ0OTQgMy42NTU3NCAyLjk0MDc3IDMuMjk3NDkgMy4zMjQ5MUwxLjkxNDkgNC44MDczNEMxLjI5NTc0IDUuNDcxMjIgMC4xODM1OTMgNS4wMzMxIDAuMTgzNTkzIDQuMTI1M0wwLjE4MzU5NCAxLjE2MDQyQzAuMTgzNTk0IDAuMjUyNjE2IDEuMjk1NzQgLTAuMTg1NTExIDEuOTE0OSAwLjQ3ODM3TDMuMjk3NDkgMS45NjA4MVoiIGZpbGw9IiM2NDY0NjQiLz4NCjwvc3ZnPg0K"


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/history/arrowright.svg
// module id = owWw
// module chunks = 0